module.exports = __webpack_public_path__ + "img/select-inside-group.ae3546e3.gif";